import React from 'react';
import SiteRateCard from './SiteRateCard';
import FeesCard from './FeesCard';
import TaxCard from './TaxCard';
import SiteTypesCard from './SiteTypesCard';
import SiteSectionsCard from './SiteSectionsCard';
import HookupTypesCard from './HookupTypesCard';
import StoreBlackoutsCard from './StoreBlackoutsCard';
import ScheduleEventsCard from './ScheduleEventsCard';
import StoreOverageFeesCard from './StoreOverageFeesCard';
import CancellationPoliciesCard from './CancellationPoliciesCard';
import DiscountCodesCard from './DiscountCodesCard';
import { SiteManagementCard } from '../SiteManagement';
import { EventsGroupBookingsCard } from '../EventsGroupBookings';
import AIAgentConfigCard from '../AIAgent/AIAgentConfigCard';
import { authService } from '../../../services/auth/authService';
import './ConfigDashboard.css';

const ConfigDashboard: React.FC = () => {
  const storeId = authService.getStoreId();

  return (
    <div className="config-dashboard">
      <div className="config-header">
        <h1 className="page-title">Campground System Configuration</h1>
        <p className="page-subtitle">
          Manage site rates, fees, taxes, events, and other system settings
        </p>
      </div>

      {/* Section 1: Store Setup (Configure these first) */}
      <div className="config-section">
        <div className="config-section-header">
          <h2>Store Setup</h2>
          <span className="config-section-note">Configure these first</span>
        </div>
        <div className="config-section-cards">
          <SiteTypesCard />
          <SiteSectionsCard />
          <HookupTypesCard />
          <StoreBlackoutsCard />
        </div>
      </div>

      {/* Section 2: Pricing & Fees (Store-wide defaults) */}
      <div className="config-section">
        <div className="config-section-header">
          <h2>Pricing & Fees</h2>
          <span className="config-section-note">Store-wide defaults</span>
        </div>
        <div className="config-section-cards">
          <SiteRateCard />
          <TaxCard />
          <FeesCard />
          <StoreOverageFeesCard />
          <CancellationPoliciesCard />
          <DiscountCodesCard />
        </div>
      </div>

      {/* Section 3: Site Management */}
      <div className="config-section">
        <div className="config-section-header">
          <h2>Site Management</h2>
          <span className="config-section-note">Requires store setup</span>
        </div>
        <div className="config-section-cards full-width">
          <SiteManagementCard />
        </div>
      </div>

      {/* Section 4: Events & Group Bookings */}
      <div className="config-section">
        <div className="config-section-header">
          <h2>Events & Group Bookings</h2>
        </div>
        <div className="config-section-cards full-width">
          <ScheduleEventsCard />
          <EventsGroupBookingsCard />
        </div>
      </div>

      {/* Section 5: AI Booking Agent */}
      {storeId && (
        <div className="config-section">
          <div className="config-section-header">
            <h2>AI Booking Agent</h2>
          </div>
          <div className="config-section-cards full-width">
            <AIAgentConfigCard store_id={storeId} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigDashboard;
